import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { MarketingScreenshotFrame } from "./MarketingScreenshotFrame";
import appGardenView from "@/assets/screenshots/app-garden-view.png";

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

export function HeroSection() {
  const { user } = useAuth();

  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Stacked content - text first, then screenshot */}
        <motion.div 
          className="text-center max-w-3xl mx-auto will-change-transform"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-medium text-foreground leading-tight tracking-tight">
            Ideas don't fail.
            <br />
            <span className="text-muted-foreground">They dissolve without structure.</span>
          </h1>

          {/* Subtext */}
          <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-lg mx-auto leading-relaxed">
            YELV is a structured thinking system for founders and operators who want their ideas to survive contact with reality.
          </p>

          {/* CTA */}
          <div className="mt-8 flex flex-col items-center gap-3">
            {user ? (
              <Button asChild size="lg" className="rounded-lg px-8 py-6 text-base font-medium shadow-md">
                <Link to="/app">Open App</Link>
              </Button>
            ) : (
              <>
                <Button asChild size="lg" className="rounded-lg px-8 py-6 text-base font-medium shadow-md">
                  <Link to="/login">Start with one idea</Link>
                </Button>
                <span className="text-sm text-muted-foreground">No credit card required</span>
              </>
            )}
          </div>
        </motion.div>

      </div>

      {/* Full-bleed screenshot section */}
      <motion.div
        className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mt-10 bg-background overflow-hidden"
        initial="hidden"
        animate="visible"
        variants={fadeInUp}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.15 }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <MarketingScreenshotFrame
            src={appGardenView}
            alt="YELV Idea Garden - capture and nurture your ideas"
            className="w-full"
          />
        </div>
      </motion.div>
    </section>
  );
}
